// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__37NwK","label":"CategoryService_label__kCGKA","location":"CategoryService_location__MJjl0"};